import { RouteConfig } from 'vue-router';

import { AttachmentType } from '@/enums/attachmentType.enum';
import { EntityType } from '@/enums/entityType.enum';
import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const documentCreatorAttachmentsRoute: RouteConfig = {
  name: 'documentCreatorAttachments',
  path: 'attachments/view',
  component: () =>
    import(
      /* webpackChunkName: "DocumentCreatorAttachments" */ '@/views/mainRoute/document/details/CreatorAttachments.vue'
    ),
  meta: {},
  beforeEnter: (to, from, next) =>
    Promise.all([
      store
        .dispatch('document/attachment/list', {
          order: 'order',
          desc: false,
          count: -1,
          entityType: EntityType.DOCUMENT,
          entityId: to.params.documentId.toString(),
          type: AttachmentType.UPLOADED
        })
        .then(() => {
          if (store.state.document?.data?.parentId) {
            return store.dispatch('document/attachment/listAppend', {
              order: 'order',
              desc: false,
              count: -1,
              entityType: EntityType.DOCUMENT,
              entityId: store.state.document.data.parentId.toString(),
              type: AttachmentType.UPLOADED
            });
          }
          if (store.state.document?.data?.children?.length) {
            return Promise.all(
              store.state.document.data.children.map((child: any) =>
                store.dispatch('document/attachment/listAppend', {
                  order: 'order',
                  desc: false,
                  count: -1,
                  entityType: EntityType.DOCUMENT,
                  entityId: child.id.toString(),
                  type: AttachmentType.UPLOADED
                })
              )
            );
          }
        }),
      store.dispatch('document/get', tryParseInt(to.params.documentId)),
      store.dispatch('setting/findPublic', {
        code: PublicSettings.PROCEDURE_ATTACHMENT_SUBDOCUMENT_NAME,
        entityType: EntityType.PROCEDURE,
        entityId: to.params.procedureId.toString()
      })
    ])
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.ATTACHMENT_CANNOT_LIST }))
};
